import { HocuspocusProvider, WebSocketStatus } from '@hocuspocus/provider';
import { useToast } from '@chakra-ui/react';
import { useOnlineStatus } from 'app/components/Offline/OfflineTracker';
import React, { useEffect, useMemo, useState } from 'react';
import debounce from 'lodash/debounce';
import { LYRICS_RECONNECTING_TOAST_ID } from 'app/components/Song/Lyrics/TextEditor/constants';
import { Alert } from 'app/components/Core/ChakraAlert';
import { AlertIcon } from 'app/store/Alerts/slice.types';

export const useEditorStatus = (provider: HocuspocusProvider) => {
  const toast = useToast();
  const { isOnline } = useOnlineStatus();
  const [status, setStatus] = useState<WebSocketStatus>(
    WebSocketStatus.Connected
  );
  const isConnected = isOnline && status === WebSocketStatus.Connected;

  const debouncedToast = useMemo(
    () =>
      debounce(() => {
        toast({
          id: LYRICS_RECONNECTING_TOAST_ID,
          duration: null,
          render: () => (
            <Alert
              title="You are not connected"
              description="Retrying..."
              icon={AlertIcon.REFRESH}
            />
          ),
          containerStyle: {
            margin: 0,
          },
        });
      }, 1500),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  useEffect(() => {
    if (status === WebSocketStatus.Connected) {
      toast.close(LYRICS_RECONNECTING_TOAST_ID);
      debouncedToast.cancel();
    }
    if (
      [WebSocketStatus.Disconnected, WebSocketStatus.Connecting].includes(
        status
      ) &&
      !toast.isActive(LYRICS_RECONNECTING_TOAST_ID)
    ) {
      debouncedToast();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [status]);

  useEffect(() => {
    provider.on('status', (event) => {
      setStatus(event.status);
    });
  }, [provider]);

  useEffect(
    () => () => {
      toast.close(LYRICS_RECONNECTING_TOAST_ID);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  return { isConnected };
};
